import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { TabView, TabPanel } from "primereact/tabview";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";


// ------------------ COMPONENTES DE BASE--------------------------
import Card from "../../../Base/Components/Card/Card";
import { toastShow } from "../../../Base/Services/ToastService";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { getDatesProduccion } from "../../../Base/Services/Moment/Luxon";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import CalendarioOperativo from "../../../Base/Components/Form/CalendarioOperativo";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";

// ------------------- CONSULTAS A LA API---------------------------
import { ObtenerIngresosEncabezado } from "../../../API/Suministros/IngresosBodega/IngresosBodegaEncabezadoRequest";
import { EliminarIngreso, EliminarItemIngreso, ObtenerIngresosDetalle } from "../../../API/Suministros/IngresosBodega/IngresosBodegaDetalleRequest";
import { getListadoDetalleOrdenes, getListadoOrdenes } from "../../../API/Compras/Ordenes/OrdenesComprasRequests";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import OrdenesComprasCrud from "../../ERP/Compras/OrdenesCompras/CrudOrdenesCompras/OrdenesComprasCrud";
import RegistroFactrasCRUD from "./RegistroFactrasCRUD";
import DetalleIngresosBodega from "./Listados/DetalleIngresosBodega";
import ListadoIngresosBodega from "./Listados/ListadoIngresosBodega";


const RegistroFacturasScreen = ({MateriaPrima = false, Servicios = false, reg = true}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);

  const [listadoEnc, setListadoEnc] = useState([]);
  const [listadoDet, setListadoDet] = useState([]);

  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [ordenDialog, setOrdenDialog] = useState(false);
  const [ingresoToShow, setIngresoToShow] = useState(null);
  const [orderToShow, setOrderToShow] = useState(null);
  const [selectedDetalle, setSelectedDetalle] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [dataOrdenes, setDataOrdenes] = useState([]);
  const [dataDetalle, setDataDetalle] = useState([]);
  const [requisaEdit, setRequisaEdit] = useState(null);
  const [showDialogI, setShowDialogI] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [habilitar, setHabilitar] = useState(true);
  const [verCostosBodega, setVerCostosBodega] = useState(false);
  const [titulo, setTitulo] = useState(null);


  const confirmarEliminacion = () => {
    if(selectedDetalle.length === 0 ){
      toastShow(toast,"warn", "Advertencia", "Selecccione al menos un ingreso.");
    }else{
      setShowConfirmDialog(true);
    }
  };

  const onHideConfirmDialog = () => {
    setShowConfirmDialog(false);
  };

  const onConfirmEliminacion = () => {
    setShowConfirmDialog(false);
    eliminarIngreso();
  };

  const getInfo = async () => {
    setLoading(true)
    setSelectedDetalle([]);
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Por favor, seleccione un rango de fechas válido."
      );
      setLoading(false)
      return;
    }
    setLoading(true);
    const fechas = getDatesProduccion(dates);

    const enc = await ObtenerIngresosEncabezado(fechas);
    const det = await ObtenerIngresosDetalle(fechas);

    setListadoEnc(enc.filter(i => i?.IdCuenta === 15 || i?.IdCuenta === 16));
    setListadoDet(det.filter(i => i?.IdCuenta === 15 || i?.IdCuenta === 16));
    
    setLoading(false)
  };

  const actualizarIngresosScreen = async () => {
    setLoading(true);
    const fechas = getDatesProduccion(dates);
    const det = await ObtenerIngresosDetalle(fechas);
    setListadoDet(det);
    setLoading(false);
  };

  const actualizarIngresosScreenListado = async () => {
    setLoading(true);
    const fechas = getDatesProduccion(dates);
    const det = await ObtenerIngresosEncabezado(fechas);
    setListadoEnc(det);
    setLoading(false);
  };

  const eliminarIngreso = async () => {
    if (selectedDetalle.length > 0) {
      try {
        const detallesCancelados = selectedDetalle.every(
          (detalle) => detalle.IdEstado === 26
        );

        if (detallesCancelados) {
          toastShow( toast, "warn", "Error", "El Detalle de requisa seleccionado ya está eliminado.");
          return;
        }

        const isListado = activeIndex;
        let response;
        if (activeIndex === 0) {
          // console.log(activeIndex);
          response = await EliminarItemIngreso(selectedDetalle.filter((detalle) => detalle.IdEstado !== 26));
          if (response[0]?.ESTADO === 1) {
            toastShow(toast, "success", "Eliminado", response[0].MENSAJE);
            actualizarIngresosScreen();
          } else {
            toastShow(toast, "error", "Error", response[0].MENSAJE);
          }
        } else {
          response = await EliminarIngreso(selectedDetalle);
          if (response[0]?.ESTADO === 1) {
            toastShow(toast, "success", "Eliminado", response[0].MENSAJE);
            getInfo();
          } else {
            toastShow(toast, "error", "Error", response[0].MENSAJE);
          }
        }
      } catch (error) {
        console.error("Error al cancelar el detalle de la requisición:", error);
        toastShow(
          toast,
          "error",
          "Error",
          "Error al eliminar el detalle de la requisición."
        );
      }
    } else {
      toastShow(
        toast,
        "error",
        "No se puede eliminar",
        "Seleccione al menos un detalle del ingreso."
      );
    }
  };

  const actualizarCompras = async () => {
    setLoading(true);
    const d = getDatesProduccion(dates);
    const t = await getListadoOrdenes(d);
    const dd = await getListadoDetalleOrdenes(d);
    setDataOrdenes(t);
    setDataDetalle(dd);
    setLoading(false);
  };

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && ingresoToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialog(null);
          setIngresoToShow(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialog(null);
      setIngresoToShow(null);
      setHabilitar(true);
    }
  };

  const cerrarModalOrdenes = () => {
    if (habilitar && orderToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setOrdenDialog(null);
          setOrderToShow(null);
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setOrdenDialog(null);
      setOrderToShow(null);
      setHabilitar(true);
    }
  };

  useEffect(() => {
    getInfo();
    let Tittle = "Registro de Facturas";
    let Tittle2 = "Registro de Facturas";
    setTitlePage(Tittle);
    setTitulo(Tittle)
    setTitlePage(getLabel(baseLang, Tittle2, config.language));
  }, [MateriaPrima, Servicios, reg]);

  return (
    <div>
      <Toast ref={toast} />
      <Dialog
        header={
          <div className="botones flex-wrap  flex-wrap">
            {titulo}
          </div>
        }
        visible={showDialog}
        onHide={() => {
          cerrarConfirmacion();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <RegistroFactrasCRUD
          idIngreso={ingresoToShow}
          setIngresoToShow={setIngresoToShow}
          showDialog={showDialog}
          actualizarIngresosScreen={actualizarIngresosScreen}
          actualizarIngresosScreenListado={actualizarIngresosScreenListado}
          setOrderToShow={setOrderToShow}
          setOrdenDialog={setOrdenDialog}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
          MateriaPrima={MateriaPrima}
          Servicios={Servicios}
          reg={reg}
        />
      </Dialog>

      <Dialog
        header="Orden de compras"
        visible={ordenDialog}
        onHide={() => {
          cerrarModalOrdenes();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <OrdenesComprasCrud
          PurchaseOrder={orderToShow}
          setOrderToShow={setOrderToShow}
          ordenDialog={ordenDialog}
          setOrdenDialog={setOrdenDialog}
          actualizarCompras={actualizarCompras}
          setRequisaDialog={setShowDialogI}
          setRequisaToShow={setRequisaEdit}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
          />
      </Dialog>

      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <h3>{getLabel(baseLang, reg ? 'Registro de Facturas' :  Servicios ? 'Ingreso de Servicios' : MateriaPrima ? "ingresosMP" : "ingresos", config.language)}</h3>
            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
            />
            <Button icon="pi pi-refresh" tooltip="Buscar" onClick={getInfo} />
            <Button
                icon="pi pi-plus"
                tooltip="Nueva"
                onClick={(e) => setShowDialog(true)}
            />
            <Button
                icon="pi pi-times"
                type="button"
                className="p-button-danger listado__botones"
                onClick={confirmarEliminacion}
                tooltip="Cancelar"
                tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                }}
                style={{ marginLeft: 1.5 }}
            />

            {(userAuth?.IdRol === 38 || userAuth?.IdRol === 25)&& (
              <Button
                icon="pi pi-eye"
                type="button"
                onClick={() => setVerCostosBodega(!verCostosBodega)}
                tooltip={verCostosBodega ? 'Ocultar Costos' : 'Ver Costos'} 
                tooltipOptions={{position: "top"}}
                style={{ marginLeft: 1.5 }}
              />
            )}


            <ConfirmDialog
              visible={showConfirmDialog}
              onHide={onHideConfirmDialog}
              message="¿Estás seguro de que deseas eliminar?"
              header="Confirmación"
              icon="pi pi-exclamation-triangle"
              acceptLabel="Sí"
              rejectLabel="No"
              accept={onConfirmEliminacion}
              reject={onHideConfirmDialog}
            />
          </div>
        }
        contenido={
          <div className="pt-4">
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Detalle">
                <DetalleIngresosBodega
                  listadoDet={listadoDet}
                  toast={toast}
                  loading={loading}
                  setListadoDet={setListadoDet}
                  setShowDialog={setShowDialog}
                  setIngresoEdit={setIngresoToShow}
                  setOrdenDialog={setOrdenDialog}
                  setOrderToShow={setOrderToShow}
                  selectedDetalle={selectedDetalle}
                  setSelectedDetalle={setSelectedDetalle}
                  verCostosBodega={verCostosBodega}
                  reg={reg}
                ></DetalleIngresosBodega>
              </TabPanel>

              <TabPanel header="Listado">
                <ListadoIngresosBodega
                  listadoEnc={listadoEnc}
                  toast={toast}
                  loading={loading}
                  setShowDialog={setShowDialog}
                  setIngresoEdit={setIngresoToShow}
                  selectedDetalle={selectedDetalle}
                  setSelectedDetalle={setSelectedDetalle}
                  verCostosBodega={verCostosBodega}
                  reg={reg}
                  getInfo={getInfo}
                ></ListadoIngresosBodega>
              </TabPanel>
            </TabView>
          </div>
        }
      />
    </div>
  );
};

export default RegistroFacturasScreen;
